export var Account={properties:{FinalUrlSuffix:{bulkDeleteValueIfEmpty:true}}};